// extracted by mini-css-extract-plugin
export default {"container":"b1jAy4","loading":"c1jAy4"};